import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  StatusCode,
  patchApiV2CustomersCustomerIdDietaryRestrictions,
} from '@hungryroot/rest';
import { invalidateCustomerDietaryRestrictions } from '../../queries/dietary-restrictions/useCustomerDietaryRestrictions';
import { invalidatePastCurrentUpcomingOrders } from '../../queries/orders/invalidatePastCurrentUpcomingOrders';

interface DietaryRestrictionSelection {
  id: number;
  selected: boolean;
}

interface PatchPayload {
  dietary_restrictions: DietaryRestrictionSelection[];
}

const FOOD_PROFILE_QUERY_KEY = ['FoodProfile'];

export function usePatchCustomerDietaryRestrictions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PatchPayload) => {
      const res = await patchApiV2CustomersCustomerIdDietaryRestrictions({
        requestBody: payload,
      });
      if (res.status !== StatusCode.SuccessOK)
        throw new Error(JSON.stringify(res.data, null, 2));
      return res.data;
    },
    onSuccess: () => {
      invalidateCustomerDietaryRestrictions(queryClient);
      invalidatePastCurrentUpcomingOrders(queryClient);
      queryClient.invalidateQueries({ queryKey: FOOD_PROFILE_QUERY_KEY });
    },
  });
}
